"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _mobxReact = require("mobx-react");

var _configuration = require("../configuration");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)({
  hoverLabel: {
    border: '1px solid black',
    position: 'absolute',
    background: '#fffa',
    pointerEvents: 'none',
    zIndex: 10000
  }
});

var Tooltip = function Tooltip(_ref) {
  var offsetX = _ref.offsetX,
      offsetY = _ref.offsetY,
      configuration = _ref.configuration,
      feature = _ref.feature,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 300 : _ref$timeout;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      shown = _useState2[0],
      setShown = _useState2[1];

  (0, _react.useEffect)(function () {
    // only show the loading message after short timeout to prevent excessive
    // flickering
    var handle = setTimeout(function () {
      return setShown(true);
    }, timeout);
    return function () {
      return clearTimeout(handle);
    };
  });

  if (feature && shown) {
    var text = (0, _configuration.readConfObject)(configuration, 'mouseover', {
      feature: feature
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.hoverLabel,
      style: {
        left: offsetX,
        top: offsetY
      }
    }, text);
  }

  return null;
};

var _default = (0, _mobxReact.observer)(Tooltip);

exports.default = _default;